import { pick } from 'lodash';

import { EXPORT_COLUMNS_CLOUD_SOURCES } from '@/constants/exportcolumns';
import { exportCsv } from '@/utils/export.utils';

import type { CloudSourceExportDataModel } from '../CloudSourcesTable/CloudSourcesTable.store';

const formatCloudSourcesForExport = (
  exportedCloudSources: CloudSourceExportDataModel[],
  selectedColumns: string[]
) => {
  // Filter the array of objects "exportedCloudSources" to only include keys that exist in "selected"
  const filteredSelected = exportedCloudSources.map((source) =>
    pick(source, selectedColumns)
  );

  // take "filteredSelected" and update the property keys to the values in "EXPORT_COLUMNS_CLOUD_SOURCES"
  // additionally, if any value is a string and is over 30000 characters, truncate it and add "..." to the end
  const mappedSelected = filteredSelected.map((ticket) => {
    const exportColumns = EXPORT_COLUMNS_CLOUD_SOURCES;
    return Object.fromEntries(
      Object.entries(ticket).map(([key, value]) => [
        exportColumns[key as keyof typeof exportColumns] || key,
        typeof value === 'string' && value.length >= 30000
          ? `${value.substring(0, 30000)}...`
          : value
      ])
    );
  });

  exportCsv(mappedSelected, 'pondurance-cloud-sources', false);
};
export default formatCloudSourcesForExport;
